import { Component, OnInit, Input, DoCheck, Optional, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, ControlContainer, FormGroupDirective, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { PhoneOptions } from '../../Shared/Models/PhoneOptions';
import { SearchCountryField, TooltipLabel } from 'ngx-intl-tel-input';

@Component({
  selector: 'BBSF-Phone',
  templateUrl: './Phone.component.html',
  styleUrls: ['./Phone.component.scss']
})
export class PhoneComponent implements OnInit {


  static controlContainerstatic = null;
  // tslint:disable-next-line: max-line-length
  constructor(private ErrorHandler: ErrorMassageValidation, private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public PhoneControlHost: FormGroupDirective) {
    PhoneComponent.controlContainerstatic = this.controlContainer;
  }
  @Input() group: FormGroup;
  @Input() options: PhoneOptions;
  @Output() OnChange = new EventEmitter();
  PhoneFormControl: AbstractControl;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  markAllAsTouched: boolean = false
  validationRules = [];
  validationRulesasync = [];
    separateDialCode = false;
  
  ngOnInit() {

    UtilityService.isCreatedBefor = false
    this.group.addControl(this.options.Name, new FormControl(''));
    this.PhoneFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);

    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);
    }
    this.PhoneFormControl.setValue(this.options.Value);

    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.validationRules.push(Validation.functionBody);
      }

    }

    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);

    this.PhoneFormControl.setValidators(this.validationRules);
    this.PhoneFormControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.PhoneFormControl.disable();
    }

    this.PhoneControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })

  }

  ngAfterViewInit(): void {
    this.controlUtility.setAttributeForControl(this.options)
  }


  resetError = () => {
    UtilityService.RemoveGlobalError();
  }


  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }
    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }

  onValueChanged() {
    let Number= this.PhoneFormControl.value.internationalNumber as string;
    this.OnChange.emit(Number.trim());
  }


  //External Method

  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.PhoneFormControl, this.validationRules, this.options)
  }
  //External Method

  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.PhoneFormControl, this.validationRules, this.options)
  }


  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.PhoneFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.PhoneFormControl, this.validationRules, CustomValidation)
  }

  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.PhoneFormControl)
  }
}


